module.exports = __webpack_public_path__ + "img/violation.8e144910.svg";